import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthenticateExtensibilityUserRequest } from "../../model/AuthenticateExtensibilityUserRequest";
import { environment } from "../../../../environments/environment";
import { PostGetQuickCareVisitRequest } from "../../model/getcarenow/PostGetQuickCareVisitRequest";
import { PostGetPatientVirtualUrgentCareRequest } from "../../model/getcarenow/PostGetPatientVirtualUrgentCareRequest";
import { PostGetPatientPrimaryCareProviderRequest } from "../../model/getcarenow/PostGetPatientPrimaryCareProviderRequest";
import { PostGetPatientInPersonUrgentCareRequest } from "../../model/getcarenow/PostGetPatientInPersonUrgentCareRequest";
import { LocationCoordinates } from "../../model/LocationCoordinates";
import { PostGetProviderSearchRequest } from "../../model/providerlocationsearch/PostGetProviderSearchRequest";
import { PostGetProviderDetailsRequest } from "../../model/providerlocationsearch/PostGetProviderDetailRequest";
import { PostGetProviderQuickSearchRequest } from "../../model/providerlocationsearch/PostGetProviderQuickSearchRequest";
import { PostGetLocationQuickSearchRequest } from "../../model/providerlocationsearch/PostGetLocationQuickSearchRequest";
import { PostGetLocationSearchRequest } from "../../model/providerlocationsearch/PostGetLocationSearchRequest";
import { PostGetLocationDetailsRequest } from "../../model/providerlocationsearch/PostGetLocationDetailRequest";
import { PostGetPatientRegistryAffiliationRequest } from "../../model/providerlocationsearch/PostGetPatientRegistryAffiliationRequest";
import { PostBedsideSurveyRequest } from "../../model/bedside-survey/PostBedsideSurveyRequest";

const headers = new HttpHeaders({
    'Content-Type':  'application/json',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'POST, GET, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Authorization, Access-Control-Allow-Origin, Access-Control-Allow-Methods, Access-Control-Allow-Headers, Ocp-Apim-Subscription-Key, Ocp-Apim-Trace',
});

var gatewayHeaders = new HttpHeaders({
    'Authorization': `Bearer ${sessionStorage.getItem("token")}`,
    'Content-Type':  'application/json',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'POST, GET, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Authorization, Access-Control-Allow-Origin, Access-Control-Allow-Methods, Access-Control-Allow-Headers,Ocp-Apim-Trace',
});

const extAuthURL = environment.MCAppGatewayBaseURL + 'ExtensibilityAuth/';
const getCareNowURL = environment.MCAppGatewayBaseURL + 'v1/GetCareNow/';
const preloginURL = environment.MCAppGatewayBaseURL + 'v1/Prelogin/';
const searchURL = environment.MCAppGatewayBaseURL + 'v1/ProviderLocationSearch/';
const bedsideSurveyURL = environment.MCAppGatewayBaseURL + 'v1/BedsideSurvey/';

@Injectable({
    providedIn: 'root'
  })
export class MCAppGatewayService {

    constructor(private http: HttpClient) {

    }

    private GetGatewayHeaders(): HttpHeaders {
        
        var authToken = sessionStorage.getItem("token");
        if (!authToken) {
            console.error("Authorization token is not available in session storage.");
            return headers
        }

        return new HttpHeaders({
            'Authorization': `Bearer ${sessionStorage.getItem("token")}`,
            'Content-Type':  'application/json',
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'POST, GET, OPTIONS',
            'Access-Control-Allow-Headers': 'Content-Type, Authorization, Access-Control-Allow-Origin, Access-Control-Allow-Methods, Access-Control-Allow-Headers'
        });
    }

    public PostAuthenticateExtensibilityUser(request : AuthenticateExtensibilityUserRequest) : Observable<any>
    {
        var actionURL =  extAuthURL + 'authenticate';
        return this.http.post(actionURL, request, {headers: headers}); 
    }
    
    public GetFhirPatientSearchR4(patientID: string, patientIDType: string): Observable<any> {
        var actionURL = extAuthURL + 'fhirpatientR4?patientID=' + patientID + '&patientIDType=' + patientIDType;
        return this.http.get(actionURL, { headers: this.GetGatewayHeaders()});
    }

    public PostGetQuickCareVisit(request : PostGetQuickCareVisitRequest): Observable<any> {
        var actionURL =  getCareNowURL + 'quickcarevisit';
        if (request.age == null || request.gender == null) {
            actionURL += '/default';
        }

        return this.http.post(actionURL, request, {headers: this.GetGatewayHeaders()}); 
    }

    public PostGetPatientVirtualUrgentCare(request : PostGetPatientVirtualUrgentCareRequest): Observable<any> {
        var actionURL =  getCareNowURL + 'virtualurgentcare';
        if (request.fhirPatientID == null || request.fhirPatientID == '' || request.patientId == null ||  request.patientId == ''  || request.patientAge == null) {
            actionURL += '/default';
        }

        return this.http.post(actionURL, request, {headers: this.GetGatewayHeaders()}); 
    }

    public PostGetPatientPrimaryCareProvider(request : PostGetPatientPrimaryCareProviderRequest): Observable<any> {
        var actionURL =  getCareNowURL + 'primarycareprovider';
        if (request.myChartAccountId == null || request.myChartAccountId == '' || request.patientId == null ||  request.patientId == ''  || request.patientAge == null) {
            actionURL += '/default';
        }

        return this.http.post(actionURL, request, {headers: this.GetGatewayHeaders()}); 
    }

    public PostGetPatientInPersonUrgentCare(request: PostGetPatientInPersonUrgentCareRequest): Observable<any> {
        var actionURL =  getCareNowURL + 'inpersonurgentcare';
        if (request.patientId == null ||  request.patientId == ''  || request.fhirPatientID == null || request.fhirPatientID == '') {
            actionURL += '/default';
        }

        return this.http.post(actionURL, request, {headers: this.GetGatewayHeaders()}); 
    }

    public PostGetCoverageBasedExperience(request : { patientID: string; fhirPatientID: string }) {
        var actionURL =  getCareNowURL + 'coveragebasedexperience';
        return this.http.post(actionURL, request, {headers: this.GetGatewayHeaders()}); 
    }

    public PostGetPreloginImage(request?: LocationCoordinates): Observable<any> {
        const actionURL = preloginURL + 'img/mobile';
        return this.http.post(actionURL, request ?? {}, { headers: headers });
    }

    public PostGetHospital(request?: LocationCoordinates): Observable<any> {
        var actionURL =  preloginURL + 'hospital';
        return this.http.post(actionURL, request ?? {}, {headers: headers}); 
    }

    public GetCityTypeAheadOptions(): Observable<any> {
        var actionURL =  searchURL + 'city/typeaheadoption';
        return this.http.get(actionURL, {headers: headers});
    }

    // Provider Search 
    public PostGetProviderSearch(request: PostGetProviderSearchRequest): Observable<any> {
        var actionURL =  searchURL + 'provider/search';
        return this.http.post(actionURL, request, {headers: headers}); 
    }

    public GetProviderSearchFilters(): Observable<any> {
        var actionURL =  searchURL + 'provider/search/filter';
        return this.http.get(actionURL, {headers: headers});
    }

    public GetProviderSearchTypeAheadOptions(): Observable<any> {
        var actionURL =  searchURL + 'provider/search/typeaheadoption';
        return this.http.get(actionURL, {headers: headers});
    }

    public PostGetProviderDetails(request: PostGetProviderDetailsRequest): Observable<any> {
        var actionURL =  searchURL + 'provider/detail';
        return this.http.post(actionURL, request, {headers: headers});
    }

    public PostGetProviderQuickSearch(request: PostGetProviderQuickSearchRequest): Observable<any> {
        var actionURL =  searchURL + 'provider/quicksearch';
        return this.http.post(actionURL, request, {headers: headers});
    }

    // Location Search
    public PostGetLocationSearch(request: PostGetLocationSearchRequest): Observable<any> {
        var actionURL =  searchURL + 'location/search';
        return this.http.post(actionURL, request, {headers: headers}); 
    }

    public GetLocationSearchFilters(): Observable<any> {
        var actionURL = searchURL + 'location/search/filter';
        return this.http.get(actionURL, {headers: headers});
    }

    public PostGetLocationDetails(request: PostGetLocationDetailsRequest): Observable<any> {
        var actionURL = searchURL + 'location/detail';
        return this.http.post(actionURL, request, {headers: headers});
    }

    public PostGetLocationQuickSearch(request: PostGetLocationQuickSearchRequest): Observable<any> {
        var actionURL = searchURL + 'location/quicksearch';
        return this.http.post(actionURL, request, {headers: headers});
    }

    public PostGetAddressFromCoordinates(request : LocationCoordinates): Observable<any> {
        var actionURL =  searchURL + 'reversegeocoding';
        return this.http.post(actionURL, request, {headers: headers});
    }

    public PostGetPatientRegistryAffiliation(request: PostGetPatientRegistryAffiliationRequest): Observable<any> {
        var actionURL =  searchURL + 'registryaffiliation';
        return this.http.post(actionURL, request, {headers: this.GetGatewayHeaders()});
    }

    public GetProviderSearchTypeAheadOption() : Observable<any> {
        var actionURL = searchURL + 'provider/search/typeaheadoption';
        return this.http.get(actionURL, {headers: headers});
    }

    public GetCityTypeAheadOption() : Observable<any> {
        var actionURL = searchURL + 'city/typeaheadoption';
        return this.http.get(actionURL, {headers: headers});
    }
    // Bedside Survey
    public PostBedsideSurvey(request: PostBedsideSurveyRequest): Observable<any> {
        var actionURL = bedsideSurveyURL;
        return this.http.post(actionURL, request, {headers: this.GetGatewayHeaders()});
    }



}